module.exports = __webpack_public_path__ + "static/UCBMUN.6c5376db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/UCBMUN.png
// module id = 117
// module chunks = 144251824217401 213534597649335